import {
  Button,
  Datagrid,
  Filter,
  FunctionField,
  List,
  ResourceContextProvider,
  SearchInput,
  SelectInput,
  TextField,
  useDataProvider,
} from "react-admin";
import CustomPriceField from "components/CustomPriceField";
import { financeStatusFilterList } from "pages/parents/conts";
import ShowDetailButton from "./ShowDetailButton";
import PostCommercialDocumentButton from "./PostCommercialDocumentButton";
import CustomDateField from "components/CustomDateField";
import RegeneratePdfButton from "./RegeneratePdfButton";

interface IInvoiceTable {
  customerId?: number;
  status?: string;
  isDueInvoice?: boolean;
  fromDueDate?: string;
  toDueDate?: string;
}

const InvoiceTable = ({
  customerId,
  status,
  isDueInvoice,
  fromDueDate,
  toDueDate,
}: IInvoiceTable) => {
  const provider = useDataProvider();

  const GetPdf = (id: number) => {
    provider
      .getOne("invoices", {
        id: id,
      })
      .then(({ data }) => {
        window.open(data.pdfUrl, "_blank");
      });
  };

  const ShowPdfButton = (props: any) => {
    return (
      <>
        {props.data.pdfUrl !== null && props.data.status === "posted" && (
          <>
            <Button
              onClick={() => {
                GetPdf(props.data.id);
              }}
              label="Show PDF"
            />
            <RegeneratePdfButton accountingDocumentNumber={props.data.number} />
          </>
        )}
      </>
    );
  };

  const PaymentHistoryFilter = (props: any) => (
    <Filter {...props}>
      <SearchInput source="search" alwaysOn />
      <SelectInput source="Status" choices={financeStatusFilterList} alwaysOn />
    </Filter>
  );

  const PaymentHistoryFilterNoStatus = (props: any) => (
    <Filter {...props}>
      <SearchInput source="search" alwaysOn />
    </Filter>
  );

  return (
    <ResourceContextProvider value="invoices">
      <List
        basePath="/invoices"
        exporter={false}
        hasCreate={false}
        actions={null}
        filters={
          status === null ? (
            <PaymentHistoryFilter />
          ) : (
            <PaymentHistoryFilterNoStatus />
          )
        }
        filterDefaultValues={{
          CustomerId: customerId,
          Status: status,
          IsDueInvoice: isDueInvoice,
          FromDueDate: fromDueDate,
          ToDueDate: toDueDate,
        }}
        sort={{ field: "createdAt", order: "DESC" }}
        bulkActionButtons={false}
        title=" "
      >
        <Datagrid>
          <TextField label="Invoice Number" source="number" emptyText="-" />
          <TextField label={"Type Invoice"} source="label" emptyText="-" />
          <TextField
            label={"Description"}
            source="items[0].description"
            emptyText="-"
          />
          {isDueInvoice && (
            <CustomDateField label={"Due Date"} source="dueDate" />
          )}
          <CustomPriceField label="Amount" source="subTotal" />
          <CustomPriceField label="Amt. Include VAT" source="total" />
          {status === "Posted" && (
            <CustomPriceField label="Remaining Amount" source="amountDue" />
          )}

          {localStorage.getItem("roles").includes("superadmin") &&
            status === "Unposted" && (
              <FunctionField
                label="Action"
                render={(record: any) => {
                  console.log("record", record);
                  return (
                    <>
                      <PostCommercialDocumentButton
                        id={record.id}
                        number={record.number}
                      />
                      {/* <DeleteCommercialDocumentButton
                        mbcRef={record.id}
                        type="id"
                      /> */}
                    </>
                  );
                }}
              />
            )}

          {status === "Posted" && (
            <FunctionField
              label="Action"
              render={(record: any) => {
                return (
                  <>
                    <ShowDetailButton detailId={record.id} />
                    <ShowPdfButton data={record} />
                  </>
                );
              }}
            />
          )}

          {status === null && <TextField label={"Status"} source="status" />}

          {status === null && (
            <FunctionField
              label="Action"
              render={(record: any) => {
                return (
                  <>
                    <ShowPdfButton data={record} />
                  </>
                );
              }}
            />
          )}
        </Datagrid>
      </List>
    </ResourceContextProvider>
  );
};

export default InvoiceTable;
